// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"d7a1ee60","760":"d1d357dd"}[chunkId] + ".chunk.js";
};